import { useQuery } from "@tanstack/react-query";
import cmsClient from "src/services/cmsClient";

interface Options {
	enabled?: boolean;
}

export const fetchUserById = async (id?: number | null) => {
	if (!id) return Promise.reject("No id");

	const url = `/store/user/${id}/`;

	const { data } = await cmsClient.get<StoreUser>(url);

	return data;
};

const useSingleStoreUser = (
	id?: number | null,
	options: Options = { enabled: true }
) => {
	const query = useQuery(["user", id], () => fetchUserById(id), {
		enabled: options.enabled
	});

	return query;
};

export default useSingleStoreUser;
